
export const FromBackground = (color) => {
	const _color = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color)
	const rgb = {
		r: parseInt(_color[1], 16),
		g: parseInt(_color[2], 16),
		b: parseInt(_color[3], 16)
	};
	const brightness = ((rgb.r << 5) + (rgb.g << 6) + (rgb.b << 2)) / 100

	return {
		bgColor: color,
		rgb: rgb,
		brightness: brightness,
		fgColor: brightness < 130 ? '#fff' : '#333'
	}
}
